import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  TERMS: {
    path: `${baseRoutes.userBaseRoutes}terms-and-conditions`,
  },
};

export default accessRoute;